class LqdColumnHandler extends elementorModules.frontend.handlers.Base {

  modelSettings = false;

  constructor(...args) {

    super(...args);

    const modelCID = this.getModelCID();

    this.modelSettings = elementorFrontend.config.elements.data[modelCID];

    if ( ! this.modelSettings ) {
      return;
    }

    this.checkSticky();

  }

  getDefaultSettings() {
    return {
      classnames: {
        sticky: 'lqd-css-sticky-column'
      }
    }
  }

  checkSticky() {

    const classnames = this.getSettings('classnames');
    const {sticky: stickyClassname} = classnames;
      
    const stickyOption = this.modelSettings.get('enable_sticky_column');
    const stickyOffset = this.modelSettings.get('sticky_column_offset');

    if ( 'yes' === stickyOption ) {
      this.$element.addClass(stickyClassname)
      this.$element.children('.elementor-widget-wrap').css('--lqd-sticky-offset', stickyOffset);
    } else {
      this.$element.removeClass(stickyClassname)
      this.$element.children('.elementor-widget-wrap').css('--lqd-sticky-offset', '');
    }


  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdColumnHandler, { $element } );
};